@import '~style-sheet-helpers/core.less';

.customers-create-label-modal {
  width: 1000px;
  height: 775px;
}

.customers-create-label-modal-body {
  display: flex;
  position: relative;
  align-items: stretch;
  height: 100%;
}
